$('.close_video_modal').click(function(e){
  e.preventDefault()
  $('.video_popup').hide();
})

$('.rich-text .button').click(function(e){
  e.preventDefault()
  $('.video_popup').css('display', 'flex');
})

$('.comments_top .button').click(function(e){
  e.preventDefault()
  $('#comment_form').slideToggle()
})

$('.upsell_info .add_to_cart').on('click', function(e){
  e.preventDefault;
  $('.product-form__submit').click()
})

$(document).ready(function(){

  if ($('body').hasClass('template-product')) {
    $('.product_carousel').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       arrows: false,
       fade: true,
       asNavFor: '.product_thumbnails'
    });
    $('.product_thumbnails').slick({
       slidesToShow: 4,
       slidesToScroll: 1,
       asNavFor: '.product_carousel',
       dots: false,
       centerMode: false,
       focusOnSelect: true
    });
  }

  setTimeout(function(){
    if ($('.product__title').html().includes('Miylk10')) {
      $('.rc-radio__subscription').each(function(){
        var string = $(this).html()
        string = string.replace('9.81%', '')
        string= string.replace('15%', '')
        $(this).html(string)
      })

    }
  },1500)

  $('.slideshow .slideshow__slide:first-of-type').addClass('active')

  setInterval(function(){

    if ($('.slideshow .slideshow__slide.active').next().length > 0) {
      $('.slideshow .slideshow__slide.active').addClass('back').removeClass('active').next().addClass('active');
      setTimeout(function(){
        $('.slideshow .slideshow__slide').removeClass('back')
      }, 3000)
    } else {
      $('.slideshow .slideshow__slide').addClass('back').removeClass('active')
      $('.slideshow .slideshow__slide:first-of-type').addClass('active')
      setTimeout(function(){
        $('.slideshow .slideshow__slide').removeClass('back')
      }, 3000)
    }
  }, 6000)
})

// $.get("https://ipinfo.io", function(response) {
//   if (response.country == "US") {
//   	$('.announcement-bar:last-child').show()
//   } else {
//     $('.announcement-bar:last-child').hide()
//   }
// }, "jsonp")
